import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'

export const renderField = (props) => {
  const {
    input,
    label,
    type,
      placeholder,
    meta: { touched, error, warning },
    disable,
    value,
  } = props
  return (
    <ReactBootstrap.Form.Group className={'mt-3 mb-3'}>
      {label && (
        <ReactBootstrap.Form.Label>
          {label}
          {error === 'Required' ? '*' : ''}
        </ReactBootstrap.Form.Label>
      )}
      <input
        disabled={disable}
        onBlur={(value) => input.onBlur(value)}
        value={value}
        spellCheck={true}
        className="form-control"
        placeholder={label||placeholder}
        type={type}
        {...input}
      />
      {touched &&
        ((error && <span className="text-danger">{error}</span>) ||
          (warning && <span className="text-warning">{warning}</span>))}
    </ReactBootstrap.Form.Group>
  )
}

export const renderFieldInline = (props) => {
  const {
    input,
    label,
    type,
      placeholder,
    meta: { touched, error, warning },
    disable,
    value,
  } = props
  return (
    <ReactBootstrap.Form.Group className={'mt-3 mb-3'}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12} md={3}>
           {label && (
        <ReactBootstrap.Form.Label>
          {label}
          {error === 'Required' ? '*' : ''}
        </ReactBootstrap.Form.Label>
      )}
        </ReactBootstrap.Col>
          <ReactBootstrap.Col xs={12} md={9}>
           <input
        disabled={disable}
        onBlur={(value) => input.onBlur(value)}
        value={value}
        spellCheck={true}
        className="form-control"
        placeholder={label||placeholder}
        type={type}
        {...input}
      />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
       <ReactBootstrap.Row>
     <ReactBootstrap.Col xs={12}>
      {touched &&
        ((error && <span className="text-danger">{error}</span>) ||
          (warning && <span className="text-warning">{warning}</span>))}
     </ReactBootstrap.Col>
       </ReactBootstrap.Row>
    </ReactBootstrap.Form.Group>
  )
}
